export const BMAT_MODULE_KEYS = ['thinking_skills', 'scientific_knowledge', 'writing'];

export const BMAT_MODULE_LABELS = {
  thinking_skills: 'Thinking Skills',
  scientific_knowledge: 'Scientific Knowledge and Applications',
  writing: 'Writing Task',
};

export const BMAT_SECTION_MINUTES = {
  thinking_skills: 60,
  scientific_knowledge: 30,
  writing: 30,
};

export const BMAT_FALLBACK_QUESTION_COUNT = {
  thinking_skills: 32,
  scientific_knowledge: 27,
  writing: 3,
};

export const BMAT_PEARSON_TITLE = 'BioMedical Admissions Test (BMAT)';

export function bmatModuleLabel(moduleKey) {
  return BMAT_MODULE_LABELS[moduleKey] || moduleKey || '';
}

export function getBmatSectionDurationMinutes(moduleKey) {
  if (!Object.prototype.hasOwnProperty.call(BMAT_SECTION_MINUTES, moduleKey)) return null;
  return BMAT_SECTION_MINUTES[moduleKey];
}

export function bmatFallbackQuestionCount(moduleKey) {
  return BMAT_FALLBACK_QUESTION_COUNT[moduleKey] || 0;
}

export function firstPresentBmatModuleKey(bmatModules) {
  return BMAT_MODULE_KEYS.find((key) => bmatModules?.[key]?.id) || null;
}

export function bmatWritingInstructionBodyCopy(maxWords) {
  const n = Number(maxWords);
  const capLine = Number.isFinite(n) && n > 0
    ? `Use the word limit given for this task (${n} words).`
    : 'If no word limit is given, aim for one A4 page / about 550 words.';
  return [
    { text: 'Answer ONE of the three BMAT Writing Task prompts.', bold: true },
    { text: "You can use the Next and Previous buttons to view all three prompts before selecting the one you wish to answer." },
    { text: 'You must only respond to ONE question. Leave the other two blank.', bold: true },
    { text: 'Communicate a reasoned argument. This Writing Task is not marked Correct or Incorrect in Review.' },
    { text: capLine },
  ];
}

export function bmatOverviewBodyCopy(presentKeys = []) {
  const paras = [];
  if (presentKeys.includes('thinking_skills')) {
    paras.push({
      text: 'Thinking Skills is multiple-choice. It covers problem solving and critical thinking. No specialist science knowledge is required. Each question is worth one mark. There is no penalty for a wrong answer. Attempt all questions.',
    });
  }
  if (presentKeys.includes('scientific_knowledge')) {
    paras.push({
      text: 'Scientific Knowledge and Applications is multiple-choice. It covers biology, chemistry, physics and mathematics at around GCSE / Key Stage 4. A calculator is not allowed. Each question is worth one mark. There is no penalty for a wrong answer. Attempt all questions.',
    });
  }
  if (presentKeys.includes('writing')) {
    paras.push({
      text: 'The Writing Task gives three prompts. Answer one. Communicate a reasoned argument. It is not marked Correct or Incorrect in Review.',
    });
  }
  return paras;
}
